<template>
	<div class="view digital-view has-footer">
		<HeaderBar @search="onSearch"
				   @clear="onClear" />
		<NavBar :fixedItemList="fixedNavItemList"
				:itemList="navItemList"
				:selectedItemId="selectedNavItem"
				:onItemClick="onNavItemClick"
				:type="1" />
		<div class="view__wrap">
			<van-pull-refresh v-model="isRefreshing"
						  @refresh="onRefresh"
						  v-infinite-scroll="loadMore"
						  :infinite-scroll-disabled="bottomLoading">
			<van-swipe @change="onSwipeChange"
					   :loop="false"
					   :show-indicators="false"
					   ref="vanSwipe">
				<van-swipe-item v-for="item in mergedItemList"
								:key="item.id">
					<Index :bannerList="bannerList"
						   :digitalList="digitalList"
						   :custom="customContent"
						   :cate_id="selectedNavItem"
						   :isNoContent="isNoContent  && firstLoaded" />
				</van-swipe-item>
			</van-swipe>
		</van-pull-refresh>
		</div>
		<PopLoading v-show="isLoading" />

	</div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import apiUtil from '../../utils/apiUtil'
import {getChannels} from '../../utils/storageUtil'
import { scrollToLeft } from '../../utils/globalUtil'
import apiConst from '../../consts/apiConst'
import HeaderBar from '../../components/HeaderBar'
import NavBar from '../../components/NavBar'
import PopLoading from '../../components/PopLoading'
import Index from './Index.vue'
export default {
	name: 'digital',
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		HeaderBar,
		NavBar,
		PopLoading,
		Index
	},
	data() {
		return {
			defaultCateId: 0,
			selectedNavItem: 0,
			bannerList: [],
			fixedNavItemList: [],
			navItemList: [],
			mergedItemList: [],
			digitalList: [],
			customContent: '',
			isLoading: false,
			isSearch: false,
			isRefreshing: false,
			isNoContent: false,
			firstLoaded: false,
			bottomLoading: false, // 是否正在触底加载
			page: 1,
			loadFinished: false, // 分页加载是否结束

		}
	},
	created() {
		this.init()
	},
	watch: {
		$route(to, from) {
			const cate_id = to.query.cate_id
			if (cate_id) {
				this.initTank(cate_id)
				this.selectedNavItem = parseInt(cate_id)
				this.cate_id = parseInt(cate_id)
			} else {
				this.initIndexView()
				// this.onSwipeChange(0)
			}
		}
	},
	methods: {
		onSwipeChange(index) {
			this.isNoContent = false;
			let id = 0
			if (index >= this.fixedNavItemList.length) {
				id = this.navItemList[index - this.fixedNavItemList.length].id
			} else {
				id = this.fixedNavItemList[index].id
			}
			if (id === this.selectedNavItem) {
				return
			}
			this.selectedNavItem = id
			this.digitalList = []
			this.customContent = ''
			if (id === this.defaultCateId) {
				// this.initIndexView(id);
				this.$router.push({ name: 'digital' })
			} else {
				this.$router.push({ name: 'digital', query: { cate_id: id } })
			}
			this.navItemScrollToView(id)

		},

		init(isDragDown = false) {
			const cate_id = this.$route.query.cate_id
			if (cate_id) {
				this.digitalList=[]
				this.initTank(cate_id, 1, isDragDown)
				this.selectedNavItem = parseInt(cate_id)
				this.cate_id = parseInt(cate_id)
			} else {
				this.initIndexView(isDragDown)
			}
		},

		async initIndexView(isDragDown = false) {
			if (!isDragDown) {
				this.isLoading = true
			}
			const res = await apiUtil.post(apiConst.getDigitalIndex, {
				cate_id: this.defaultCateId
			})
			this.isLoading = false
			this.isRefreshing = false
			if (res) {
				const {
					home_banner,
					category: { group_a, group_b }
				} = res
				if (this.selectedNavItem === 0) {
					this.selectedNavItem = group_a[0].id
				}
				this.fixedNavItemList = group_a.map(ele => {
					ele.isHardItem = true
					if (ele.cate_name === '定制') {
						ele.hasChildren = true
					}
					return ele
				})
				const temp = getChannels() || {};
				const favList = (temp && temp["1"]) ? temp["1"] : [];
				this.navItemList = favList.length > 0 ? favList : group_b;
				this.mergedItemList = this.fixedNavItemList.concat(this.navItemList)
				this.bannerList = home_banner
				if (group_a.length > 0) {
					this.defaultCateId = group_a[0].id
					this.initTank(group_a[0].id, 1)
				}
			}
		},

		async initTank(id, page = 1, isDragDown) {
			const res = await apiUtil.post(apiConst.getDigitalTank, {
				cate_id: id,
				page,
				pagesize: 30
			})
			this.isRefreshing = false

			if (res) {
				const {
					digital: { list, content },
					category: { group_a, group_b }
				} = res
				this.page = page;
				this.digitalList = this.digitalList.concat(list)
				if (list && list.length === 0) {
					this.isNoContent = true;
				}
				if (content) {
					this.customContent = content
				}
				if(typeof list !="undefined"){
					if (list.length < 30) {
						this.loadFinished = true;
					}

				}else{
					this.loadFinished = true;
				}
				
				this.fixedNavItemList = group_a.map(ele => {
					ele.isHardItem = true
					if (ele.cate_name === '定制') {
						ele.hasChildren = true
					}
					return ele
				})
				const temp = getChannels() || {};
				const favList = temp ? temp["1"] : [];
				this.navItemList = favList && favList.length > 0 ? favList : group_b;
				if (group_a.length > 0) {
					this.defaultCateId = group_a[0].id
				}
				this.mergedItemList = this.fixedNavItemList.concat(this.navItemList)

				const index = this.mergedItemList.findIndex(ele => ele.id == id)
				if (index > -1) {
					//this.$refs.vanSwipe.swipeTo(index);
				}
				this.firstLoaded = true;
			}
		},

		loadMore() {
			if (!this.loadFinished && this.firstLoaded) {
				this.initTank(this.selectedNavItemId, this.page + 1, false)
			}
		},

		async onSearch(str) {
			// if (str) {
			//   this.digitalList = [];
			//   this.customContent = '';
			//   const res = await apiUtil.post(apiConst.getSearch, {
			//     keyword: str,
			//     type: 2
			//   });
			//   if (res.success) {
			//     this.digitalList = res.list;
			//   }
			// } else {
			//   this.initIndexView();
			// }
			this.$router.push({
				name: 'search',
				query: {
					keyword: str,
					type: 2
				}
			})
		},

		navItemScrollToView(id){
			const navItem = this.$el.querySelector('#navItem_'+id);
			const wrapper = this.$el.querySelector('#navListNormal');

			if(navItem){				// wrapper.scrollTo(navItem.offsetLeft ,0)
				scrollToLeft(wrapper, navItem.offsetLeft, 200)
			}
		},

		onNavItemClick(item, index) {
			this.isNoContent = false;
			this.onSwipeChange(index)
			this.selectedNavItem = item.id;
			this.$refs.vanSwipe.swipeTo(index);
		},
		onClear() {
			this.isSearch = false
		},

		onRefresh() {
			this.init(true)
		}
	}
}
</script>
<style lang="stylus">
.digital-view {
	height: 100%;
	/* padding-top: 176px; */
	position: relative;
	.content-wrap img{
		max-width:100%;
	}
	.swiper-view {
		.news-list {
			padding: 0 15px;
		}

		.banner-img {
			display: block;
			width: 100%;
			height: 100%;
			border-radius: 12px;
		}
	}
}
</style>
